export class ContentErrors {
  errorMessages: Map<string, ContentError> = new Map();

  constructor(contentjson?: any) {
    if (contentjson && contentjson['errormessages']) {
      this.fillError(contentjson['errormessages']);
    }
  }

  fillError(contentjson) {
    this.errorMessages = new Map();
    if (contentjson) {
      for (const error of contentjson) {
        this.errorMessages.set(error['errorId'], new ContentError(error));
      }
    }
  }
}

export class ContentError {
  errorId: any;
  errorMessageTitle: any;
  errorMessageDescription: any;

  constructor(errorjson?: any) {
    if (errorjson) {
      this.errorId = errorjson['errorId'];
      this.errorMessageTitle = errorjson['errorMessageTitle'];
      this.errorMessageDescription = errorjson['errorMessageDescription'];
    }
  }
}
